import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// Import environments
import { environment as localEnv } from './environments/environment';
import { environment as devEnv } from './environments/environment.dev';
import { environment as qaEnv } from './environments/environment.qa';
import { environment as prodEnv } from './environments/environment.prod';

const ENVIRONMENT_MAP: Record<string, any> = {
  'localhost': localEnv,
  'dev.cblrd.lexus.com': devEnv,
  'qa.cblrd.lexus.com': qaEnv,
  'cblrd.lexus.com': prodEnv
};

const hostname = location.hostname.toLowerCase();

const selectedEnvironment = ENVIRONMENT_MAP[hostname] ?? localEnv; 
  globalThis.environment = { ...selectedEnvironment };


    bootstrapApplication(AppComponent, appConfig).catch((err) => { console.info(err); }); 
